// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FontColorsOutlinedSvg from "@ant-design/icons-svg/es/asn/FontColorsOutlined";
import AntdIcon from '../components/AntdIcon';

var FontColorsOutlined = function FontColorsOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FontColorsOutlinedSvg
  }));
};

FontColorsOutlined.displayName = 'FontColorsOutlined';
export default React.forwardRef(FontColorsOutlined);